function pageLoadStyleguide() {
  // code here
  // console.log('pageLoadStyleguide complete');
}

document.addEventListener('DOMContentLoaded', pageLoadStyleguide);
